"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/IMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_110)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_110`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#E52D42"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.6 4.78594H18.3859L16.014 10.414L13.6 8.807C13.6 8.807 11.8666 4.65963 11.1859 4.02103C10.5052 3.34033 9.87366 3.97893 7.75437 4.5684C5.67717 5.15787 5.59296 5.88068 4.79296 5.88068C4.45612 5.88068 3.39647 4.65261 2.8491 4.31577C1.99998 3.7684 1.66314 4.02103 1.87366 4.82103C1.95787 5.15787 2.63858 5.58594 3.05963 6.21752C3.607 7.02454 3.95086 8.03507 3.95086 8.03507C3.95086 8.03507 4.71577 7.31226 5.13682 7.18595C5.7684 7.01752 6.49121 7.31226 7.34033 7.18595C8.39998 7.01752 9.54384 6.42103 9.54384 6.42103L9.83858 9.46665C9.83858 9.46665 6.02805 13.0245 6.36489 14.421C6.70173 15.8175 10.3017 17.5509 11.1509 18.821C12 20.0491 10.6456 20.5123 10.6456 21.1088C10.6456 21.7052 10.5193 22.5052 11.1509 22.2526C11.7824 22 11.8737 20.9824 12.4631 20.0491C12.8842 19.4175 13.1859 19.0737 13.2702 18.821C13.3965 18.1895 11.621 16.5754 10.6456 15.3895C10.1824 14.8421 9.2491 14.0772 9.2491 14.0772L12 12C12 12 16.7438 13.9438 17.7965 13.3123C18.8561 12.6807 19.1509 6.41402 19.1509 6.41402L22.4491 5.607L21.6 4.78594Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.6 18.414C13.179 18.414 12.793 18.0772 12.793 17.607C12.793 17.1368 13.1298 16.8 13.6 16.8C14.0211 16.8 14.407 17.1368 14.407 17.607C14.407 18.0772 14.0211 18.414 13.6 18.414ZM16.814 5.58596C16.393 5.58596 16.007 5.24912 16.007 4.77894C16.007 4.30877 16.3439 3.97192 16.814 3.97192C17.2351 3.97192 17.6211 4.30877 17.6211 4.77894C17.6211 5.24912 17.2351 5.58596 16.814 5.58596ZM16.814 11.9789C16.393 11.9789 16.007 11.6421 16.007 11.1719C16.007 10.7509 16.3439 10.3649 16.814 10.3649C17.2351 10.3649 17.6211 10.7017 17.6211 11.1719C17.579 11.6421 17.2351 11.9789 16.814 11.9789ZM7.20703 15.193C6.78597 15.193 6.40001 14.8561 6.40001 14.386C6.40001 13.9649 6.73685 13.5789 7.20703 13.5789C7.67018 13.5789 8.01404 13.9158 8.01404 14.386C8.01404 14.8561 7.62808 15.193 7.20703 15.193ZM10.379 5.58596C9.9579 5.58596 9.57194 5.24912 9.57194 4.77894C9.57194 4.30877 9.90878 3.97192 10.379 3.97192C10.8 3.97192 11.186 4.30877 11.186 4.77894C11.186 5.24912 10.8491 5.58596 10.379 5.58596ZM11.986 11.9789C11.5649 11.9789 11.179 11.2561 11.179 10.3719C11.179 9.48771 11.5158 8.76491 11.986 8.76491C12.407 8.76491 12.793 9.48771 12.793 10.3719C12.793 11.2561 12.4561 11.9789 11.986 11.9789ZM3.98597 8.80701C3.56492 8.80701 3.17896 8.47017 3.17896 7.99999C3.17896 7.53684 3.5158 7.19298 3.98597 7.19298C4.44913 7.19298 4.79299 7.52982 4.79299 7.99999C4.79299 8.46315 4.45615 8.80701 3.98597 8.80701Z",
					fill: "#F8DD4E"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_110`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as IMFlag };
